import { Injectable } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class OrderingService {
  orderingCollectionRef: AngularFirestoreCollection<any>;
  dbOrdering = firebase.firestore().collection('ordering');
  constructor(private angularFirestore: AngularFirestore) {
    this.orderingCollectionRef = this.angularFirestore.collection<any>('ordering');
  }

  queryDataRealtime(key: string, pala, value) {
    return this.dbOrdering.where(key, pala, value);
  }

  queryData(key: string, pala, value) {
    return this.dbOrdering.where(key, pala, value).get();
  }

  add(data) {
    data.createdAt = firebase.firestore.FieldValue.serverTimestamp();
    return this.orderingCollectionRef.add(data);
  }

  delete(id) {
    return this.orderingCollectionRef.doc(id).delete();
  }

  getAll() {
    return this.orderingCollectionRef.valueChanges();
  }

  getOneAll() {
    return this.orderingCollectionRef.ref.get();
  }

  getByUserId(userId) {
    return this.dbOrdering.where('userId', '==', userId).get();
  }

  getById(id) {
    return this.orderingCollectionRef.doc(id).valueChanges();
  }

  getOneById(id) {
    return this.orderingCollectionRef.doc(id).ref.get();
  }

  updateIdOrder(uid) {
    return this.orderingCollectionRef.doc(uid).update({ id: uid });
  }

  updateOrder(uid, data) {
    data.updateAt = firebase.firestore.FieldValue.serverTimestamp();
    return this.orderingCollectionRef.doc(uid).update(data);
  }

  getTimestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }
}
